import { useState } from 'react'
import Container from '@components/container'
import {
  StyleAuthActionWrapper,
  StyleAuthRow,
  StyleAuthWrapper,
} from '../style'
import AuthBanner from '../components/banner'
import AuthHeader from '../components/header'
import { Formik, Form } from 'formik'
import Column from '@components/column'
import Fields from '@components/fields'
import Button from '@components/button'
import Typography from '@components/typography'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { Otp } from '@apis'
import { AuthSchema } from '@validations'
const VerifyPage = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const handleResend = async () => {}
  const submitHandler = async (values) => {
    setLoading(true)
    await Otp.verify({
      data: {
        otp: values?.otp,
        phoneNo: state?.phoneNo,
        countryCode: state?.countryCode,
        token: state?.token,
      },
    })
      .then((resp) => {
        navigate('/register', {
          state: {
            ...state,
            token: resp?.token,
          },
        })
      })
      .catch(() => {})
    setLoading(false)
  }
  if (!state?.token) {
    return <Navigate to="/" />
  }
  return (
    <StyleAuthWrapper>
      <Container>
        <StyleAuthRow>
          <AuthBanner />
          <StyleAuthActionWrapper>
            <AuthHeader title="Verify Your" tag="OTP" />
            <Column
              alignItems="center"
              rowGap={5}
              styleColumn="margin-top:40px;margin-bottom:15px;"
            >
              <Typography
                size={12}
                content={`Enter 6 digits code that we've sent to your ${state?.email ? 'email' : 'mobile number'}`}
              />
              <Typography
                size={12}
                content={
                  !!state?.email
                    ? `${state?.email}`
                    : `+${state?.countryCode} ${state?.phoneNo}`
                }
                tc="secondary"
              />
            </Column>
            <Formik
              initialValues={{
                otp: null,
              }}
              onSubmit={submitHandler}
              validationSchema={AuthSchema.otpVerifyValidationSchema}
            >
              {({ handleSubmit }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <Column rowGap={20}>
                      <Fields.OtpInput
                        name="otp"
                        length={6}
                        onResend={handleResend}
                      />
                      <Column styleColumn="margin-top:30px;">
                        <Button
                          type="submit"
                          title="Continue"
                          styleButton="width:100%"
                          height={40}
                          loading={loading}
                        />
                      </Column>
                    </Column>
                  </Form>
                )
              }}
            </Formik>
          </StyleAuthActionWrapper>
        </StyleAuthRow>
      </Container>
    </StyleAuthWrapper>
  )
}

export default VerifyPage
